// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"cbf60b2f","5266":"cbf60b2f","5454":"7ec9664c","5546":"cbf60b2f","9596":"cbf60b2f"}[chunkId] + ".chunk.css";
};